import styled from '@emotion/styled'
import { FadeInUp } from 'app/components/Common/Animation/FadeInUp'
import React, { memo } from 'react'

export interface Props {
  className?: string
  pax?: string
  size?: string
}

export const Info = memo(function Info({ className, pax, size }: Props) {
  if (!pax && !size) {
    return null
  }

  return (
    <Container className={className}>
      {size ? (
        <Item>
          <Value>{size.split(' ')[0]}</Value>
          <Text>{size.split(' ')[1]}</Text>
        </Item>
      ) : null}

      {pax ? (
        <Item>
          {' '}
          <Value>{pax.split(' ')[0]}</Value>
          <Text>{pax.split(' ')[1]}</Text>
        </Item>
      ) : null}
    </Container>
  )
})

const Container = styled(FadeInUp)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 1199px) {
    margin-top: 1.5rem;
    padding: 0 2rem;
  }
`

const Item = styled.div`
  display: inline-flex;
  align-items: center;
  &:nth-of-type(2) {
    &:before {
      content: '';
      width: 5rem;
      height: 0.0625rem;
      background: ${({ theme }) => theme.colors.variants.primaryDark};
      margin: 0 1rem;
    }
  }

  @media (max-width: 1199px) {
    &:nth-of-type(2) {
      &:before {
        width: 3rem;
        margin: 0 1.5rem;
      }
    }
  }
`

const Value = styled.span`
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 1.5rem;
  font-weight: 300;
  line-height: 1.75rem;
`

const Text = styled.span`
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.875rem;
  font-variation-settings: 'wght' 300;
  line-height: 1.0625rem;
  margin-left: 0.25rem;
`
